import {ErrorMessages} from "./errorMessage";
import {PeselUtility} from "./peselUtility";
import Validator, {ValidatorModel} from "./validator";

export const clientValidators: ValidatorModel = {
    regon: [
        { name: "regonIsNotEmpty", fn: Validator.isNotEmpty, errorMessage: ErrorMessages.required },
        { name: "regonIsValid", fn: Validator.regon, errorMessage: ErrorMessages.client.regon }
    ],
    nip: [
        { name: "nipIsValid", fn: Validator.nip, errorMessage: ErrorMessages.client.nip }
    ],
    legalForm: [
        { name: "legalFormIsNotNullOrUndefined", fn: Validator.inNotNullOrUndefined, errorMessage: ErrorMessages.required }
    ],
    companyName: [
        { name: "companyNameIsNotEmpty", fn: Validator.isNotEmpty, errorMessage: ErrorMessages.required},
        { name: "companyNameIsNotNullOrUndefined", fn: Validator.inNotNullOrUndefined, errorMessage: ErrorMessages.required }
    ],
    firstName: [
        { name: "firstNameIsNotEmpty", fn: Validator.isNotEmpty, errorMessage: ErrorMessages.required },
        { name: "firstNameIsNotNullOrUndefined", fn: Validator.inNotNullOrUndefined, errorMessage: ErrorMessages.required },
        { name: "firstNameIsIncorrect", fn: Validator.personalName, errorMessage: ErrorMessages.client.firstName }
    ],
    lastName: [
        { name: "lastNameIsNotEmpty", fn: Validator.isNotEmpty, errorMessage: ErrorMessages.required },
        { name: "lastNameIsNotNullOrUndefined", fn: Validator.inNotNullOrUndefined, errorMessage: ErrorMessages.required },
        { name: "lastNameIsIncorrect", fn: Validator.personalName, errorMessage: ErrorMessages.client.lastName }
    ],
    pesel: [
        { name: "peselIsNotEmpty", fn: Validator.isNotEmpty, errorMessage: ErrorMessages.required },
        { name: "peselIsNotNullOrUndefined", fn: Validator.inNotNullOrUndefined, errorMessage: ErrorMessages.required },
        { name: "peselIsIncorrect", fn: Validator.pesel, errorMessage: ErrorMessages.client.pesel }
    ],
    peselAgeOver60: [
        { name: "peselAgeUnderIs60", fn: PeselUtility.isAgeOver60FromPesel, errorMessage: ErrorMessages.safeSenior.ageUnder60 }
    ]
};
